import { useRootSelector } from '../../store/hooks';
import { selectPageConfig } from '../../store/features/pageConfig';
import { useTranslation } from 'react-i18next';
import { selectOptions } from '../../store/features/options';
import { localizePath } from '../../helpers/locale';

export function useBuildUrl(pageType: string, path: string) {
  const { i18n } = useTranslation();
  const { sitePath } = useRootSelector(selectPageConfig);
  const { locales } = useRootSelector(selectOptions);
  const url = `/${sitePath}/${pageType}/${path}`;

  return localizePath(url, i18n.language, locales.primary);
}
